/**
 * @author jakubbujakowski
 * @since 2020-4-2
 */

import * as React from "react";
import styled from "styled-components";

import { HIDE_TOOLTIP_AFTER } from "@config/consts";

import { ITheme } from "@ui/themes/ThemeInterface";
import { TestProps, TestWrapper, Tooltip } from "@ui/Atoms";

interface Props extends TestProps {
  className?: string;
  children?: React.ReactNode;
  theme?: ITheme;
  value: string;
  copiedToClipboardText: string;
  toastTestId?: TestProps["testId"];
}

const CopyToClipboard = (props: Props): React.ReactElement => {
  const [showSuccess, setShowSuccess] = React.useState<boolean>(false);

  const textAreaRef = React.useRef<HTMLTextAreaElement>(null);

  const handleCopy = (): void => {
    textAreaRef.current && textAreaRef.current.select();
    document.execCommand("copy");
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, HIDE_TOOLTIP_AFTER);
  };

  return (
    <TestWrapper testId={props.testId}>
      <CopyToClipboardWrapper className={props.className} onClick={handleCopy}>
        <Tooltip
          testId={props.toastTestId}
          placeholder={props.copiedToClipboardText}
          id={String(new Date().getTime())}
          isVisible={showSuccess}
          disabled={!showSuccess}
        >
          <div></div>
        </Tooltip>
        {props.children}
        <HiddenTextArea ref={textAreaRef} defaultValue={props.value} readOnly />
      </CopyToClipboardWrapper>
    </TestWrapper>
  );
};

const CopyToClipboardWrapper = styled.div`
  cursor: pointer;
`;

const HiddenTextArea = styled.textarea`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  transform: scale(0);
  z-index: -1;
`;

CopyToClipboard.displayName = "CopyToClipboard";

export { CopyToClipboard };
